import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjectCard, fetchProjectTransactionAggregates } from '../project-actions';
import Loading from '../../components/Loading';
import NotFound from '../not-found/NotFound';
import { getProjectFromId } from '../projects-reducer';
import { ProjectEmbeddedComponent } from './ProjectEmbeddedComponent';

export const ProjectEmbeddedComponentWrapper = ({ projectId }) => {
    const dispatch = useDispatch();
    const isFetching = useSelector((state) => state.projects.isFetchingCards);
    const project = useSelector((state) => getProjectFromId(state, projectId));

    useEffect(() => {
        if (projectId) {
            dispatch(fetchProjectCard(projectId));
            dispatch(fetchProjectTransactionAggregates(projectId));
        }
    }, [projectId, dispatch]);

    if (isFetching && !project) {
        return <Loading />;
    }

    if (!project) {
        return <NotFound />;
    }

    return <ProjectEmbeddedComponent project={project} small={true} />;
};
